import exampleImg1 from '../assets/promotion/example-1.png'
import exampleImg2 from '../assets/promotion/example-2.png'
import exampleImg3 from '../assets/promotion/example-3.png'
import exampleImg4 from '../assets/promotion/example-4.png'
import exampleImg5 from '../assets/promotion/example-5.png'
import exampleImg6 from '../assets/promotion/example-6.png'

export const EXAMPLE_DATA = [
  {
    label: '壹钱包',
    title: '壹钱包——中国平安旗下一站式金融生活购物平台',
    text: `<div>壹钱包致力于为用户的每一分创造价值。</div>
    <div>聚焦于理财、购物、生活、支付、积分等五大金融增值及消费场景，为用户提供覆盖线上线下的综合支付服务，帮助用户管理资金、账户以及积分、购物消费等，通过为用户提供金融理财与消费支付服务，打造智慧全能钱包。</div>`,
    img: exampleImg5,
  },
  {
    label: '骑士卡',
    title: '全球购骑士卡——国内领先的会员制特权电商平台',
    text: `<div>全球购骑士卡汇聚国内外“吃喝玩乐买”超过300项会员专属优惠特权。</div>
    <div>骑士会员能以优惠价购买服饰鞋包、美容彩妆、营养保健、数码家电等各类商品。</div>
    <div>全球购骑士卡已累计服务超5000万用户，建立唯品商品与5000万用户的关系纽带。</div>`,
    img: exampleImg6,
  },
  {
    label: '关爱通',
    title: '关爱通——人力资源服务公司',
    text: `<div>关爱通是国务院国资委系统中专业从事人力资源服务的全国性公司中智公司旗下子公司，企业客户超过8500家。</div>
    <div>关爱通能够帮助企业在不同预算状态下（有预算、无预算）实现对员工的福利关怀。</div>
    <div>关爱通首创“爱在其中”生态圈共赢理念，依托领先的唯品互联网平台技术，整合优质社会资源，帮助企业实施“以人为本”的企业文化，让员工在满足个性化需求的同时回馈社会。实现有效的关爱传递，感受爱，传递爱！</div>`,
    img: exampleImg3,
  },
  {
    label: '口袋银行',
    title: '口袋银行——平安银行移动金融服务平台',
    text: `<div>平安口袋银行是为中国大陆12家全国性股份制商业银行之一，以“金融”板块为核心，延伸出“生活优惠”和“积分商城”两大板块。</div>
    <div>依托唯品强大供应链和快捷物流保障，覆盖衣食住行各大品类的金融消费场景和海量优惠活动；同时可以使用积分消费和信用卡分期付款，通过构建场景和生态，把金融嵌入到零售和电商领域中。</div>
    <div>为客户提供一个安全、快捷、便利的移动银行服务体验，让生活变得更简单。</div>`,
    img: exampleImg4,
  },
  {
    label: '百联',
    title: '安付宝——百联集团旗下第三方支付公司',
    text: `<div>作为百联电子商务，及百联集团下属7000多家网点提供第三方支付服务的唯一平台，并进一步服务于百联集团以外的企业，与中国主流商业银行组织建立了密切的合作关系。</div>
    <div>通过优势资源的整合、各方面的技术和经营创新，将传统支付与网上支付结合起来，多用于预付卡可以在原OK卡特约商户和安付宝特约商户共计13000多家门店和百联E城等网站、96801电话平台等网点和渠道使用。</div>
    <div>服务和支付涉及手机充值、公共事业缴费、虚拟游戏卡、机票、彩票和保险等多项业务，同时对接唯品强大供应链和快捷物流保障，覆盖衣食住行各大品类的金融消费场景和海量优惠活动。</div>`,
    img: exampleImg2,
    h5Text: `<div>作为百联电子商务，及百联集团下属7000多家网点提供第三方支付服务的唯一平台，并与中国主流商业银行组织建立了密切的合作关系，在原OK卡特约商户和安付宝特约商户共计13000多家门店和百联E城等网站、96801电话平台等网点和渠道使用。</div>
    <div>安付宝的服务和支付涉及手机充值、公共事业缴费、虚拟游戏卡、机票、彩票和保险等多项业务，同时对接唯品强大供应链和快捷物流保障，覆盖衣食住行各大品类的金融消费场景和海量优惠活动。</div>`
  },
  {
    label: '丰享福',
    title: '丰享福——顺丰员工积分福利平台',
    text: `<div>通过对接唯品丰富货品池及快捷物流配送能力，对外提供一站式企业综合福利解决方案，为各企业福利平台定制，传统节令采买，弹性化连接企业福利与员工的桥梁；</div>
    <div>并支持公司福利、奖励等多类型发放，上百个应用场景，让企业每一个员工全场景随心购，满意度直线上升，企业更省时省力省心。</div>`,
    img: exampleImg1,
  },
]


// WEBPACK FOOTER //
// ./src/config/constants.js